import gql from "graphql-tag";

export const AddJobApplication = gql`
  mutation createJobApplication($input: AddJobApplicationInput) {
    createJobApplication(input: $input) {
      jobId
      firstName
      lastName
      emailAddress
      phoneNumber
      website
      memberNumber
      attachments {
        filename
        type
      }
    }
  }
`;
